import type { Stripe } from '@stripe/stripe-js';
import type { InjectionKey, Ref } from 'vue';
import { type StatusPlugin, type UploadPlugin } from './types';

export const StripeInjectKey = Symbol('stripe') as InjectionKey<Ref<Stripe>>;

export const UploadFileInjectKey = Symbol('uploadFile') as InjectionKey<UploadPlugin>;

export const StatusInjectKey = Symbol('status') as InjectionKey<StatusPlugin>;

export default { StripeInjectKey };
